import React from 'react'
import { Link } from 'react-router-dom'
import Constant, { getCountryTimeZone } from '../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import axios from 'axios'
import Loader from '../../common/Loader'
import { Dialog, DialogContent } from '@material-ui/core'
import Select from 'react-select'
import Button from '../../common/CustomComponents/Button'
import { write, utils } from 'xlsx'
import moment from 'moment'

class FlightRedirectList extends React.Component {
  state = {
    flight_data: [],
    countryList: [],
    codes: [],
    open: false,
    limit: 10,
    pageNumber: 0,
    disabled: false,
    keyword: '',
    country: '',

    isSearching: false,
    flightViewer: false,
    countryData: null,
    filterBy: 'today',
    from: moment().subtract(1, 'd').format('YYYY-MM-DD'),
    to: moment().subtract(1, 'd').format('YYYY-MM-DD'),
    minToDate: null,
    maxToDate: moment().subtract(1, 'd').format('YYYY-MM-DD'),
    minFromDate: null,
    maxFromDate: moment().subtract(1, 'd').format('YYYY-MM-DD'),
    totalCommission: 0,
    filteredTotalCommission: 0,
    totalSale: 0,
    filteredTotalSale: 0,
    bookingStatus: '',
  }

  componentDidMount = async () => {
    await this.getCountries()
    this.getFlightRedirectList()
  }

  getCountries = async () => {
    await axios
      .get(Constant.getAPI() + '/multi-country/list-countries?show_all_countries=true&all_countries=true', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name:
            localStorage.getItem('loged_In_role') === 'super-admin'
              ? ''
              : `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            countryList: res.data.data.map((itm) => ({
              label: `${itm.country_name_en}/${itm.country_name_ar}`,
              value: itm.id,
              two_letter_code_en: itm.two_letter_code_en,
              country_short_name: itm.country_short_name,
              country_name: itm.country_name,
            })),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getFlightRedirectList = async () => {
    if (this.state.filterBy === 'custom') {
      if (!this.state.from) {
        Swal.fire('Please select from date', '', 'error')
        return
      }
      if (!this.state.to) {
        Swal.fire('Please select to date', '', 'error')
        return
      }
    }

    this.setState({
      isSearching: true,
      open: true,
      flight_data: [],
    })

    await axios
      .get(Constant.getAPI() + `/admin/get-flight-redirects`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          pageNumber: this.state.pageNumber,
          limit: this.state.limit,
          countryCode: this.state.countryData?.two_letter_code_en,
          from: this.state.from,
          to: this.state.to,
          bookingStatus: this.state.bookingStatus,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            flight_data: res.data.data?.flights,
            codes: res.data.data?.codes,
            totalCommission: res.data.data?.totalCommission,
            filteredTotalCommission: res.data.data?.filteredTotalCommission,
            totalSale: res.data.data?.totalSale,
            filteredTotalSale: res.data.data?.filteredTotalSale,
            open: false,
            disabled: !Object.keys(res.data?.pagination?.next || {}).length > 0,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
        this.setState({
          open: false,
        })
      })
      .finally(() => {
        this.setState({
          isSearching: false,
        })
      })
  }

  handleChange = (event) => {
    event.persist()
    const today = moment().subtract(1, 'd').format('YYYY-MM-DD')

    this.setState(
      {
        [event?.target?.name]: event?.target?.value,
      },
      () => {
        if (event?.target?.name === 'from') {
          const fromDate = event?.target?.value
          const maxToDate = moment(fromDate, 'YYYY-MM-DD').add(30, 'd').format('YYYY-MM-DD')

          this.setState({
            to: '',
            minToDate: fromDate,
            maxToDate: moment.min(moment(maxToDate), moment(today)).format('YYYY-MM-DD'), // Cap at today
          })
        }

        if (event?.target?.name === 'to') {
          const fromDate = this.state.from
          const maxAllowed = moment
            .min(moment(fromDate, 'YYYY-MM-DD').add(30, 'days'), moment(today))
            .format('YYYY-MM-DD')

          const toDate = event.target.value > maxAllowed ? maxAllowed : event.target.value

          this.setState({ to: toDate })
        }
      }
    )
  }

  searchData = async () => {
    this.setState(
      {
        limit: 10,
        pageNumber: 0,
      },
      () => {
        this.getFlightRedirectList()
      }
    )
  }

  clearFilters = () => {
    this.setState({
      keyword: '',

      limit: 10,
      pageNumber: 0,

      flight_data: [],
      countryData: null,
      filterBy: 'today',
      from: null,
      to: null,
      minToDate: null,
      maxToDate: null,
      minFromDate: null,
      maxFromDate: null,
      filteredTotalCommission: 0,
      filteredTotalSale: 0,
    })
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.searchData()
    }
  }

  hideFlightDetails = () => {
    this.setState({
      flightViewer: false,
      selectedFlightDetail: {},
    })
  }

  showFlightDetails = (id) => {
    if (id) {
      this.setState({
        selectedFlightDetail: this.state.flight_data.find((item) => item.id == id),
        flightViewer: true,
      })
    }
  }

  getAirportName = (code) => {
    return this.state.codes?.find((ele) => ele.code === code)?.name
  }

  getProvider = (url) => {
    const match = url?.match(/[?&]integration_code=([^&]+)/)
    const integrationCode = match ? decodeURIComponent(match?.[1]) : null
    return integrationCode
  }

  getNationality = (twoLetterCode) => {
    const selectedCountry = this.state.countryList?.find((ele) => ele.two_letter_code_en === twoLetterCode)
    return selectedCountry?.country_name
  }

  handleCountryChange = (event) => {
    this.setState({ countryData: event })
  }

  handleClear = () => {
    this.setState({ countryData: null })
  }

  render() {
    const flightViewer = () => {
      return (
        <Dialog
          fullWidth={true}
          maxWidth={'md'}
          open={this.state.flightViewer}
          onClose={this.hideFlightDetails}
        >
          <DialogContent>
            <div className="container">
              {/* User Details Section */}
              {this.state.selectedFlightDetail?.user && (
                <div className="card mb-4">
                  <div className="card-header">
                    <h4 className="mb-0">User Details</h4>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <strong>Name:</strong> {this.state.selectedFlightDetail?.created_by}
                      </div>
                      <div className="col-md-6 mb-3">
                        <strong>Gender:</strong> {this.state.selectedFlightDetail?.user?.gender || '--'}
                      </div>
                      <div className="col-md-6 mb-3">
                        <strong>DOB:</strong> {this.state.selectedFlightDetail?.user?.dob || '--'}
                      </div>
                      <div className="col-md-6 mb-3">
                        <strong>Email:</strong> {this.state.selectedFlightDetail?.user?.email || '--'}
                      </div>
                      <div className="col-md-6 mb-3">
                        <strong>Phone:</strong> {this.state.selectedFlightDetail?.user?.phone || '--'}
                      </div>
                      <div className="col-md-6 mb-3">
                        <strong>Nationality:</strong>{' '}
                        {this.state.selectedFlightDetail?.user?.user_nationality?.country_name_en || '--'}
                      </div>
                      <div className="col-md-6 mb-3">
                        <strong>Email Verified:</strong>{' '}
                        {this.state.selectedFlightDetail?.user?.is_email_verified ? 'Yes' : 'No'}
                      </div>
                      <div className="col-md-6 mb-3">
                        <strong>Phone Verified:</strong>{' '}
                        {this.state.selectedFlightDetail?.user?.is_phone_verified ? 'Yes' : 'No'}
                      </div>
                      <div className="col-md-6 mb-3">
                        <strong>Device Type:</strong> {this.state.selectedFlightDetail?.device_type || '--'}
                      </div>
                      <div className="col-md-6 mb-3">
                        <strong>Device Model:</strong> {this.state.selectedFlightDetail?.device_model || '--'}
                      </div>
                      <div className="col-md-6 mb-3">
                        <strong>User Created At:</strong>{' '}
                        {this.state.selectedFlightDetail?.user?.created_at
                          ? moment(this.state.selectedFlightDetail.user.created_at)
                              .tz(getCountryTimeZone(localStorage.getItem('countryShortName' || 'KWT')))
                              .format('YYYY-MM-DD hh:mm A')
                          : '--'}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Flight Details Section */}
              <div className="card">
                <div className="card-header">
                  <h4 className="mb-0">Flight Details</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <strong>Search ID:</strong> {this.state.selectedFlightDetail?.search_id || '--'}
                    </div>
                    <div className="col-md-4 mb-3">
                      <strong>Trip Type:</strong> {this.state.selectedFlightDetail?.trip_type || '--'}
                    </div>
                    <div className="col-md-4 mb-3">
                      <strong>Cabin:</strong> {this.state.selectedFlightDetail?.cabin || '--'}
                    </div>
                    <div className="col-md-4 mb-3">
                      <strong>Adults Count:</strong> {this.state.selectedFlightDetail?.adultsCount ?? '--'}
                    </div>
                    <div className="col-md-4 mb-3">
                      <strong>Children Count:</strong> {this.state.selectedFlightDetail?.childrenCount ?? '--'}
                    </div>
                    <div className="col-md-4 mb-3">
                      <strong>Infants Count:</strong> {this.state.selectedFlightDetail?.infantsCount ?? '--'}
                    </div>
                    <div className="col-md-4 mb-3">
                      <strong>Provider:</strong> {this.getProvider(this.state.selectedFlightDetail?.url) || '--'}
                    </div>
                    <div className="col-md-4 mb-3">
                      <strong>User Country Origin:</strong>{' '}
                      {this.getNationality(this.state.selectedFlightDetail?.userCountryCode) || '--'}
                    </div>
                    <div className="col-md-4 mb-3">
                      <strong>Price:</strong> {this.state.selectedFlightDetail?.price ?? '--'}
                    </div>
                    <div className="col-md-4 mb-3">
                      <strong>Search Date/Time:</strong> {this.state.selectedFlightDetail?.created_at ?? '--'}
                    </div>
                    <div className="col-md-4 mb-3">
                      <strong>Total Price USD:</strong> {this.state.selectedFlightDetail?.total_price_usd ?? '--'}
                    </div>
                    <div className="col-md-4 mb-3">
                      <strong>Commission USD:</strong> {this.state.selectedFlightDetail?.commission_usd ?? '--'}
                    </div>
                  </div>
                  <div className="mt-3">
                    <h6>Legs</h6>
                    {this.state.selectedFlightDetail?.legs?.length > 0 ? (
                      this.state.selectedFlightDetail.legs.map((leg, idx) => (
                        <div
                          key={idx}
                          className="mb-2"
                        >
                          Trip {idx + 1}:{' '}
                          {`{ date: ${leg.outboundDate}, from: ${this.getAirportName(leg.departureCity?.code) || leg.departureCity?.name}, to: ${this.getAirportName(leg.arrivalCity?.code) || leg.arrivalCity?.name} }`}
                        </div>
                      ))
                    ) : (
                      <div>No Trips Data Available</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      )
    }

    const columns = [
      {
        name: 'created_by',
        label: 'User',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'trip_type',
        label: 'Trip Type',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'cabin',
        label: 'Cabin',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'provider',
        label: 'Provider',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'price',
        label: 'Price',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'commission_usd',
        label: 'Commission $',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'conversions_tracked',
        label: 'Booking Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (
            <span
              style={{
                color: value ? '#15803d' : '#b91c1c',
                fontWeight: '900',
              }}
            >
              {value ? 'Confirmed' : 'Pending'}
            </span>
          ),
        },
      },
      {
        name: 'userCountryCode',
        label: 'Country',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) =>
            value ? <div style={{ textWrap: 'nowrap' }}>{this.getNationality(value)}</div> : '--',
        },
      },
      {
        name: 'deviceType',
        label: 'Device Type',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'device_type',
        label: 'Device OS',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'device_model',
        label: 'Device Name',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'created_at',
        label: 'Search Date/Time',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'id',
        label: 'View Trip Details',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (booking, tableMeta) => {
            const id = tableMeta.rowData[tableMeta.rowData.length - 1]
            return (
              <div className="d-flex justify-content-around">
                <div
                  onClick={() => {
                    this.showFlightDetails(id)
                  }}
                >
                  <i className="f-20 icofont icofont-eye"></i>
                </div>
              </div>
            )
          },
        },
      },
    ]

    const options = {
      filter: false,
      viewColumns: false,
      print: false,
      search: false,
      download: true,
      downloadOptions: {
        filename: 'Flight-Redirect',
      },
      onDownload: (buildHead, buildBody, columns, values) => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        const fileExtension = '.xlsx'
        const fileName = `Flight-Redirect`

        const json = values.reduce((result, val) => {
          const temp = {}
          val.data.forEach((v, idx) => {
            if (!['View Trip Details'].includes(columns[idx]?.label)) {
              temp[columns[idx].label] = v
            }
          })
          result.push(temp)
          return result
        }, [])

        const ws = utils.json_to_sheet(json)
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' })
        const blob = new Blob([excelBuffer], { type: fileType })
        const file = new File([blob], fileName + fileExtension, { type: fileType })

        const downloadLink = document.createElement('a')
        downloadLink.href = URL.createObjectURL(file)
        downloadLink.download = file.name

        downloadLink.click()
        return false
      },
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.open ? <Loader open={this.state.open} /> : 'Sorry, No Booking Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <>
        <div className="pcoded-inner-content">
          <div className="main-body">
            <div className="page-wrapper">
              <div className="page-header">
                <div className="row align-items-end">
                  <div className="col-lg-8">
                    <div className="page-header-title">
                      <div className="d-inline">
                        <h4>Flight Redirect list</h4>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="page-header-breadcrumb">
                      <ul className="breadcrumb-title">
                        <li className="breadcrumb-item">
                          <Link to="/">
                            <i className="feather icon-home"></i>{' '}
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">Flight Redirect List</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="page-body">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="card card-border-default">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Country</label>
                              <div className="col-sm-9">
                                <Select
                                  name="countryData"
                                  value={this.state.countryData}
                                  onChange={this.handleCountryChange}
                                  options={this.state.countryList}
                                  isMulti={false}
                                  isSearchable={true}
                                  isClearable
                                  onClear={this.handleClear}
                                  placeholder="Select Options"
                                  styles={{
                                    menu: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                      position: 'absolute',
                                      width: '100%',
                                    }),
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          {/* <div className="col-md-4">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Filter By</label>
                              <div className="col-sm-9">
                                <select
                                  name="filterBy"
                                  className="form-control"
                                  value={this.state.filterBy}
                                  onChange={this.handleChange}
                                >
                                  <option value={'today'}>Today</option>
                                  <option value={'custom'}>Custom</option>
                                </select>
                              </div>
                            </div>
                          </div> */}
                          {/* {
                            this.state.filterBy === 'custom' &&
                            <> */}
                          <div className="col-md-4">
                            <div className="form-group row">
                              <label className="col-md-3 col-form-label">From Date</label>
                              <div className="col-md-9">
                                <input
                                  type="date"
                                  id="from"
                                  className="form-control"
                                  value={this.state?.from}
                                  name="from"
                                  onChange={this.handleChange}
                                  min={this.state.minFromDate}
                                  max={this.state.maxFromDate}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group row">
                              <label className="col-md-3 col-form-label">To Date</label>
                              <div className="col-md-9">
                                <input
                                  type="date"
                                  id="to"
                                  className="form-control"
                                  value={this.state?.to}
                                  name="to"
                                  onChange={this.handleChange}
                                  min={this.state.minToDate}
                                  max={this.state.maxToDate}
                                />
                              </div>
                            </div>
                          </div>
                          {/* </>
                          } */}
                          <div className="col-md-4">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Booking Status</label>
                              <div className="col-sm-9">
                                <select
                                  name="bookingStatus"
                                  className="form-control"
                                  value={this.state.bookingStatus}
                                  onChange={this.handleChange}
                                >
                                  <option value={''}>All</option>
                                  <option value={'0'}>Pending</option>
                                  <option value={'1'}>Confirmed</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group row">
                              <div
                                className="col-12"
                                style={{ color: 'red' }}
                              >
                                You can get maximum 30 days rocords at a time
                              </div>
                              <div className="text-left col mt-2">
                                <Button
                                  onClick={this.searchData}
                                  disabled={this.state.isSearching}
                                >
                                  {this.state.isSearching ? 'Searching...' : 'Search'}
                                </Button>
                                <Button
                                  variant={'outlined'}
                                  onClick={this.clearFilters}
                                >
                                  Clear
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card card-border-default">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-1"></div>
                          <div className="col-md-4">
                            <div
                              className="row"
                              style={{ fontSize: 18 }}
                            >
                              <div className="col-12 text-center font-weight-bold">Full Record</div>
                              <div className="col-8">Total Commission: </div>
                              <div className="col-4 text-right">{this.state.totalCommission + ' $'}</div>
                              <div className="col-8">Total Sale(Confirmed Bookings): </div>
                              <div className="col-4 text-right">{this.state.totalSale + ' $'}</div>
                            </div>
                          </div>
                          <div className="col-md-2"></div>
                          <div className="col-md-4">
                            <div
                              className="row"
                              style={{ fontSize: 18 }}
                            >
                              <div className="col-12 text-center font-weight-bold">Filtered Records</div>
                              <div className="col-8">Total Commission: </div>
                              <div className="col-4 text-right">{this.state.filteredTotalCommission + ' $'}</div>
                              <div className="col-8">Total Sale(Confirmed Bookings): </div>
                              <div className="col-4 text-right">{this.state.filteredTotalSale + ' $'}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="page-body">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="card">
                      <div className="card-block">
                        <div className="dt-responsive table-responsive">
                          <MUIDataTable
                            title={''}
                            className="table-responsive"
                            data={this.state.flight_data}
                            columns={columns}
                            options={options}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {flightViewer()}
        </div>
      </>
    )
  }
}

export default FlightRedirectList
